import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class ApiDependency  extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                    <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">
                            API Dependency Matrix
                        </h1>

                        <section class="docs-intro">
                            <p>
                                The following matrix shows the dependency relationship between
                                each API in the remittance transaction flow. APIs should be
                                invoked only after all prerequisite APIs have been completed
                                successfully.
                            </p>
                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                API Dependency Matrix
                            </h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>API</th>
                                        <th>Depends On</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Get Remittance Countries</td>
                                        <td>None</td>
                                    </tr>

                                    <tr>
                                        <td>Get Available Corridors</td>
                                        <td>Get Remittance Countries</td>
                                    </tr>

                                    <tr>
                                        <td>Calculate Exchange Rates</td>
                                        <td>Get Available Corridors</td>
                                    </tr>

                                    <tr>
                                        <td>Get Payout List</td>
                                        <td>Get Available Corridors</td>
                                    </tr>

                                    <tr>
                                        <td>Get Recipient Form</td>
                                        <td>Get Available Corridors, Get Payout List</td>
                                    </tr>

                                    <tr>
                                        <td>Get Branch Codes</td>
                                        <td>Get Available Corridors, Get Payout List</td>
                                    </tr>

                                    <tr>
                                        <td>Make Payment</td>
                                        <td>All Previous APIs</td>
                                    </tr>

                                    <tr>
                                        <td>Get Transaction Detail</td>
                                        <td>Make Payment</td>
                                    </tr>

                                </tbody>
                            </table>

                        </section>
                    </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-integration-workflow"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Integration Workflow
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-error-handling"
                                            >
                                                Error Handling&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}